import React from 'react'
import { connect } from 'react-redux';
import Wix from 'Wix';
import UI from 'editor-ui-lib';
import { settingsActions, menuActions, premiumActions } from './actions'
import { configAnimations, clearShowAllCaptionController, nextSlideHook } from '../Utils/animationsConfiger'
import dynamics from 'dynamics.js'
import { LtPoweredBy, WidgetContainerStyle, LightSlider, GetLightSliderContainer, LightSliderContainer, AttentionContainer, Watermark } from './style'
import Slide from './modules/Slide';
// import * as checkPremiumHelpers from './api/checkPremiumHelpers'
import * as utils from './api/utils'
import server from './api/server';
import { default as settingsServer } from '../settings/api/server';
import { transpileSettings } from './api/prevVersionSettingsTranspiler';
import _ from 'lodash'
import background from './image/defaultNoSlideBG.jpg'
import trial_add_widget_tooltip from './image/trial_add_widget_tooltip.png'
import { pojemnikApi } from '../Utils/pojemnikApi';
import { getCaptionsAdaptedToTypingAnimation, getSettingsCorrectedToPremium, getSiteLang, getVisibleSlides, setCheckWindowClosed, setLanguageSettingsToCaptions } from '../Utils/utils';
import IncognitoMode from './modules/Slide/IncognitoMode';
import { prepareSettingsAndSendGA, saveWidgetInstances } from '../Utils/GA';
import { WidgetRateLogicWatcher } from '../settings/modules/RateLogic';
import { detectBrowser } from '../Utils/pojemnikApi/utils';
import { MixHelper } from '../Utils/Mix';
import { vectorArrowsArray } from '../settings/modules/SettingsView/NavigationView/ArrowsSection/DefaultArrows';
import { ARROWS_DESIGN, clampValue, remapValue } from '../Utils/helpers';
import { RenderPreset } from '../Utils/svgPresets';
import { calculateAbsoluteFromCenterPoint, calculateCenterPointFromAbsolute, getImageDimensions } from '../editSlide/modules/MainView/Workspace/Captions/ImageCaption';

function getUrlVars() {
    let vars = [],
        hash,
        hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    _.each(hashes, (hashElement) => {
        hash = hashElement.split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    })

    return vars;
};
function getUrlVar(name) {
    return getUrlVars()[name];
};


class WidgetContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            parallaxImage: {
                fileName: null,
                height: null,
                width: null,
                relativeUri: null,
                scale: null,
                offsetX: null,
                offsetY: null,
                // spaceY: null,

                mobileScale: null,
                mobileOffsetX: null,
                mobileOffsetY: null,
                isIncognito: false,
            },
            sliderStyle: {
                dotsColor: null,
                dotsColorActive: null,
                dotsSize: null,
                dotsSpacing: null,
                dotsColorHover: null,
                dotsMargin: null,
                hasNavigationOnHover: null,

                arrowScale: 1,
                prevArrowMargin: null,
                nextArrowMargin: null,
            },

            deviceType: null,
            showTrialAddSaleTooltip: false,
            play3DState: true,
        }


        this.captionContainersClassnames = []
        this.captionsClassnames = [];
        this.typewriterMap = new Map()

        this.currentSlide = 0;
        this.captionAnimated = false;
        this.shooted = false;
        this.slideWrapperElement = null

        this.lightSlider = null;

        this.resizeTimeout = null;
        this.curentCaptionIndex = null
        this.stopAnimations = false
        this.allCaptionIn = false
        // остановить проигрывание капч при ховере
        this.stopAnimateCaptions = false
    }


    componentWillMount() {
        // Wix.Utils.getViewMode() - ненадёжная функция, поэтому значение viewMode записываем в сессию в эвенте при смене viewMode
        let viewMode = Wix.Utils.getViewMode()
        if (viewMode !== 'site') {
            let sessionViewMode = null
            try {
                sessionViewMode = sessionStorage.getItem('text-slider-edit-mode')
            } catch (e) {
                console.warn('"Incognito mode" or "Block third-party cookies"', e)
                this.setState({ isIncognito: true })
                return
            }
            viewMode = sessionViewMode || viewMode
        }
        const deviceType = Wix.Utils.getDeviceType();
        this.setState({
            deviceType,
            sliderStyle: this.getSliderStyle(this.props.settingsReducer, deviceType),
            viewMode
        })
    }

    componentDidUpdate(prevProps, prevState) {

        const settingsReducer = _.cloneDeep(this.props.settingsReducer)
        // console.log('settingsReducer',settingsReducer);

        const compId = Wix.Utils.getCompId()
        const viewMode = Wix.Utils.getViewMode()
        if (viewMode !== 'site') {
            // проверяем, нужно ли проигрывать демонстрацию темплейта
            let demoTemplate = null
            try {
                demoTemplate = JSON.parse(sessionStorage.getItem('demo-'.concat(compId)))
            } catch (e) {
                console.warn('"Incognito mode" or "Block third-party cookies"', e)
                return
            }
            if (demoTemplate && this.props.settingsReducer.demoIsShow !== true) {
                this.props.dispatch(settingsActions.previewTemplateSlides(demoTemplate))
            }
        }

        const getNewEditedWidth = prevProps.settingsReducer.widgetDimensions.editedWidth !== settingsReducer.widgetDimensions.editedWidth
        const getNewEditedHeight = prevProps.settingsReducer.widgetDimensions.editedHeight !== settingsReducer.widgetDimensions.editedHeight
        if (getNewEditedWidth || getNewEditedHeight) {
            const deviceType = Wix.Utils.getDeviceType();
            this.setState({
                parallaxImage: utils.convertParallaxImage(
                    settingsReducer.parallaxImage[0],
                    settingsReducer.widgetDimensions.editedWidth,
                    settingsReducer.widgetDimensions.editedHeight,
                    window.innerWidth,
                    this.getSliderVerticalHeight(),
                    deviceType === 'mobile'
                ),
                deviceType,
                sliderStyle: this.getSliderStyle(this.props.settingsReducer, deviceType),
            })
        }

    }

    initAutosave() {
        const compId = Wix.Utils.getCompId()
        const APP_NAME = 'impressive-text-slider-'.concat(compId);

        setCheckWindowClosed('settings', compId, () => { this.saveSettingsToDB(APP_NAME, server.editSettings) })
    }

    publishChanges() {
        const compId = Wix.Utils.getCompId()
        const APP_NAME = 'impressive-text-slider-'.concat(compId);
        const siteOwnerId = Wix.Utils.getSiteOwnerId()
        console.log('published', compId)
        let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
        if (sessionStorage.getItem('text-slider-publish-list')) {
            const list = JSON.parse(sessionStorage.getItem('text-slider-publish-list'))
            const listSettings = JSON.parse(sessionStorage.getItem('text-slider-publish-list-settings'))
            if (!list.includes(compId)) {
                list.push(compId)
                listSettings.push(storageData)
                sessionStorage.setItem('text-slider-publish-list', JSON.stringify(list))
                sessionStorage.setItem('text-slider-publish-list-settings', JSON.stringify(listSettings))
            }
        } else {
            // console.log('storageData.settings', storageData.settings)
            sessionStorage.setItem('text-slider-publish-list', JSON.stringify([compId]))
            sessionStorage.setItem('text-slider-publish-list-settings', JSON.stringify([storageData]))
        }
        setTimeout(() => {
            const list = JSON.parse(sessionStorage.getItem('text-slider-publish-list'))
            const listSettings = JSON.parse(sessionStorage.getItem('text-slider-publish-list-settings'))

            if (list && list.length >= 1 && list.indexOf(compId) === 0) {
                console.log('publish', list.length)
                const settingsObjectForServer = {}
                for (let comp of list) {
                    if (listSettings[list.indexOf(comp)] != null) {
                        settingsObjectForServer[comp] = listSettings[list.indexOf(comp)].settings
                    }
                }
                // console.log('settingsObjectForServer', settingsObjectForServer)
                server.sitePublishedMulti(settingsObjectForServer).then(() => {
                    sessionStorage.setItem(`text-slider-${compId}-published`, 'true')
                })
                sessionStorage.removeItem('text-slider-publish-list')
                sessionStorage.removeItem('text-slider-publish-list-settings')
            }
        }, 500)
        MixHelper.events.slideshowPublished(storageData.settings)
    }

    async componentDidMount() {

        // console.log('edit w did',this.props.settingsReducer.widgetDimensions.editedWidth, 'edit h',this.props.settingsReducer.widgetDimensions.editedHeight);
        const compId = Wix.Utils.getCompId()
        const APP_NAME = 'impressive-text-slider-'.concat(compId);
        // const APP_PUBLISHED_NAME = 'impressive-text-slider-'.concat(compId).concat('-published');
        const viewMode = Wix.Utils.getViewMode()

        if (viewMode != 'site') {
            this.initAutosave()
        }

        // Родительский ID
        const origCompId = getUrlVar('originCompId')
        // если есть родительский элемент и записи в сессии нет, то надо проверить, а не дефолтные ли настройки приходят
        // если да, то копируем в наш элемент настройки родителя
        // делаем это только не на паблише
        if (viewMode !== 'site' && origCompId != undefined && !sessionStorage.getItem(APP_NAME)) {
            // console.log('COPY');
            let data = await server.getSettings()
            const origSS = JSON.parse(sessionStorage.getItem(`impressive-text-slider-${origCompId}`))

            // если в сессии есть запись родительской сессии, то копируем её
            if (origSS && origSS.settings && (origSS.settings.lastDateUpdate > data.settings.lastDateUpdate)) {
                sessionStorage.setItem(APP_NAME, JSON.stringify(origSS))
                const resp = await server.editSettings(origSS)
                // console.log(resp)
                window.location = window.location;
            }
        }
        await this.initSlider(viewMode)


        if (viewMode !== 'site') {

            try {
                sessionStorage.getItem('testIncognito')
            } catch (e) {
                console.warn('Is incognito', e)
                return
            }



            Wix.addEventListener(Wix.Events.SITE_SAVED, async () => {
                this.saveSettingsToDB(APP_NAME, server.editSettings)
            })

            Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, (data) => {
                console.log(data)
                if (data.action == 'playState3d') {
                    // console.log('playState3d',data.playState3d)
                    this.setState({ play3DState: data.newPlayState })
                    return
                }
                if (data.action == 'autosave') {
                    // console.log('autosave')
                    this.saveSettingsToDB(APP_NAME, server.editSettings)
                    return
                }

                if (data.action === 'publish-changes') {
                    this.publishChanges()
                    return;
                }

                if (data === compId) {
                    window.location = window.location
                }




                if (data.compId === compId) {

                    if (data.useThisSettings) {
                        // использую передачу настроек не через сессию, а через виксовую функцию
                        // сохраняю в сессию и перезагружаю. После перезагрузки читаю настройки из сессии.
                        sessionStorage.setItem('impressive-text-slider-'.concat(compId), JSON.stringify({ ...this.props.premiumReducer, settings: data.settings }))

                    }
                    else if (data.settings) {
                        // console.log('data.settings', data.settings);
                        // если сессия была удалена, то из settings придут настройки через виксовую функцию
                        // эти настройки сохраняем в сессию, чтобы при перезагрузке использовать их
                        sessionStorage.setItem('temp-settings-'.concat(compId), JSON.stringify(data.settings))

                    }
                    else if (data.demo == 'watch') {
                        // console.log('demo watch',data.template)
                        // просмотр демонстрации темплейта в виджете
                        sessionStorage.setItem('demo-'.concat(compId), JSON.stringify(data.template))

                    } else if (data.demo == 'stop') {
                        // console.log('demo stop')
                        // остановка демонстрации темплейта в виджете
                        this.props.dispatch(settingsActions.stopShowTemplate())

                    } else if (data.reloadWithSavingReducerToSession) {
                        // Если нет в сессии объекта, то можем перед перезагрузкой сохранить настройки из редюсера в сессию
                        // это для того, чтобы при очистке сессии пользователь не потерял настройки, которые уже сделал в редакторе
                        // применяется этот метод при открытии окна settings и отсутствующей сессии
                        sessionStorage.setItem('impressive-text-slider-'.concat(compId), JSON.stringify({ ...this.props.premiumReducer, settings: this.props.settingsReducer }))

                    } else if (data.toPremiumReducer) {
                        // для сохранения настроек уведомлений на случай, если сессия сотрётся
                        this.props.dispatch(premiumActions.updateSomePremiumParams(data.toPremiumReducer))

                    } else {
                        sessionStorage.removeItem('demo-'.concat(compId))

                        const sessionData = JSON.parse(sessionStorage.getItem(APP_NAME))
                        if (sessionData) {
                            sessionData.settings.lastDateUpdate = Date.now()
                            sessionStorage.setItem(APP_NAME, JSON.stringify(sessionData))
                        }

                    }
                    let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
                    if (!storageData) {
                        console.log('empty session')
                    }
                    console.log('RELOAD');
                    window.location = window.location
                }
            })

            Wix.addEventListener(Wix.Events.SITE_PUBLISHED, () => {
                // const siteOwnerId = Wix.Utils.getSiteOwnerId()
                // console.log('published', compId)
                // let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
                // if (sessionStorage.getItem('text-slider-publish-list')) {
                //     const list = JSON.parse(sessionStorage.getItem('text-slider-publish-list'))
                //     const listSettings = JSON.parse(sessionStorage.getItem('text-slider-publish-list-settings'))
                //     if (!list.includes(compId)) {
                //         list.push(compId)
                //         listSettings.push(storageData)
                //         sessionStorage.setItem('text-slider-publish-list', JSON.stringify(list))
                //         sessionStorage.setItem('text-slider-publish-list-settings', JSON.stringify(listSettings))
                //     }
                // } else {
                //     // console.log('storageData.settings', storageData.settings)
                //     sessionStorage.setItem('text-slider-publish-list', JSON.stringify([compId]))
                //     sessionStorage.setItem('text-slider-publish-list-settings', JSON.stringify([storageData]))
                // }
                // setTimeout(() => {
                //     const list = JSON.parse(sessionStorage.getItem('text-slider-publish-list'))
                //     const listSettings = JSON.parse(sessionStorage.getItem('text-slider-publish-list-settings'))

                //     if (list && list.length >= 1 && list.indexOf(compId) === 0) {
                //         console.log('publish', list.length)
                //         const settingsObjectForServer = {}
                //         for (let comp of list) {
                //             if (listSettings[list.indexOf(comp)] != null) {
                //                 settingsObjectForServer[comp] = listSettings[list.indexOf(comp)].settings
                //             }
                //         }
                //         // console.log('settingsObjectForServer', settingsObjectForServer)
                //         server.sitePublishedMulti(settingsObjectForServer)
                //         sessionStorage.removeItem('text-slider-publish-list')
                //         sessionStorage.removeItem('text-slider-publish-list-settings')
                //     }
                // }, 500)
                // MixHelper.events.slideshowPublished(storageData.settings)
                this.publishChanges()
                return
                // if (siteOwnerId === 'fdaafd0b-99e0-4de8-b1e4-8c6aa5f8da60') {
                if (sessionStorage.getItem('text-slider-block-publish') == 'true') {
                    return
                }
                sessionStorage.setItem('text-slider-block-publish', 'true')
                // }

                setTimeout(() => {
                    if (sessionStorage.getItem('text-slider-block-publish') == 'true') {
                        sessionStorage.removeItem('text-slider-block-publish')
                    }
                }, 3000)
                this.saveSettingsToDB(APP_NAME, server.sitePublished)
                // let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
                if (storageData) {
                    // подготовить и отправить данные в гугл аналитику
                    prepareSettingsAndSendGA(storageData)
                }

            })

            Wix.addEventListener(Wix.Events.COMPONENT_DELETED, () => {
                MixHelper.events.slideshowDeleted(this.props.settingsReducer)
                server.deleteSettings()
                pojemnikApi.handleDeleteComponent(this.props.premiumReducer.isProfessionalPremium, "text_slider");

            })

            Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, data => {
                sessionStorage.setItem('text-slider-edit-mode', data.editMode)
                // перезагрузка при переходе в превью и обратно
                let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
                if (!storageData && !this.props.settingsReducer.demoIsShow) {
                    console.log('empty session')

                    sessionStorage.setItem('impressive-text-slider-'.concat(compId), JSON.stringify({ ...this.props.premiumReducer, settings: this.props.settingsReducer }))
                }
                window.location = window.location
            })

            // не всегда корректно срабатывает функция Wix.Utils.getViewMode() во время перезагрузки виджета
            // возможно слишком много вычислений одновременно. Но в таймауте срабатывает лучше. 
            // так же Wix.Events.EDIT_MODE_CHANGE иногда не срабатывает
            // поэтому если в таймауте значение не совпадает с тем, что уже есть в стейте, то перезагружаем
            // такое происходит примерно в 10% случаев.
            setTimeout(() => {
                const viewMode = Wix.Utils.getViewMode()
                if (this.state.viewMode !== viewMode && !this.state.isIncognito) {
                    console.error('reload: viewMode was wrong. Set:', viewMode)
                    try {
                        sessionStorage.setItem('text-slider-edit-mode', viewMode)
                    } catch (e) {
                        console.error('catch sessionStorage', e)
                    }
                    window.location = window.location
                }
            }, 1000)

        }

        window.addEventListener('resize', () => {
            console.log('RESIZE');
            if (this.resizeTimeout !== null) {
                clearTimeout(this.resizeTimeout);
            }
            this.resizeTimeout = setTimeout(() => {
                try {
                    // удаляю бекап, если он есть. Ведь в нём настройки для предыдущего размера
                    localStorage.removeItem('text-slider-backUpStorage-'.concat(compId))

                    let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
                    if (!storageData && !this.props.settingsReducer.demoIsShow) {
                        console.log('empty session')
                        sessionStorage.setItem('impressive-text-slider-'.concat(compId), JSON.stringify({ ...this.props.premiumReducer, settings: this.props.settingsReducer }))
                    }
                } catch (e) {
                    console.error('catch sessionStorage', e)
                }
                // console.log('resize timeout end')
                window.location.reload()
            }, 200);
        })

        saveWidgetInstances()
    }

    // сохранить или опубликовать настройки
    async saveSettingsToDB(APP_NAME, callback) {
        let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
        if (storageData) {
            if (!storageData.settings.templatePreview) {
                storageData.settings.templatePreview = {
                    needShow: false,
                    templateIndex: 0,
                }
            } else {
                storageData.settings.templatePreview.needShow = false
            }
            const response = await callback(storageData)
            sessionStorage.removeItem('text-slider-block-publish')
            console.log('SITE SAVED!!')
            MixHelper.events.slideshowSaved(storageData.settings)
        }
        // не сохраняем из редюсера, пока не загрузятся данные, иначе сохраним дефолтное состояние
        else if (this.props.settingsReducer.dataIsLoad) {
            const reducerSettings = { settings: this.props.settingsReducer }
            if (!reducerSettings.settings.templatePreview) {
                reducerSettings.settings.templatePreview = {
                    needShow: false,
                    templateIndex: 0,
                }
            } else {
                reducerSettings.settings.templatePreview.needShow = false
            }
            const response = await callback(reducerSettings)
            console.log('SITE SAVED!! from reducer');
            MixHelper.events.slideshowSaved(reducerSettings.settings)
        }
    }


    componentWillReceiveProps(nextProps) {
        const deviceType = Wix.Utils.getDeviceType();
        this.setState({
            deviceType,
            sliderStyle: this.getSliderStyle(nextProps.settingsReducer, deviceType)
        })
    }

    shouldComponentUpdate(nextProps) {
        let needUpdate = true;

        if (this.props.menuReducer.currentSlide != nextProps.menuReducer.currentSlide) {
            needUpdate = false
        }

        return needUpdate
    }

    async initSlider(viewMode) {
        const locale = Wix.Utils.getLocale()
        const langFromWixFunction = await getSiteLang()

        const lang = langFromWixFunction || locale;
        // если сайт паказан на основном языке, то на опубликованном сайте параметра языка нет, 
        // поэтому получаем язык создателя сайта через Wix.Utils.getLocale()
        this.setState({ lang, locale })

        if (viewMode === 'site') {
            // в режиме инкогнито обращение к сессии вызывает ошибку
            let data = await server.getSettings()
            // console.log('site response from server', _.cloneDeep(data))
            let useSettings = data && data.publishedSettings
            // console.log('useSettings', useSettings)
            // в предыдущей версии настройки не разделялись на паблиш и на эдитор. Всё хранилось в settings
            if (data && data.settings && !data.publishedSettings) {
                useSettings = data.settings
            }
            // console.log('useSettings',_.cloneDeep(useSettings))
            data.publishedSettings = transpileSettings(useSettings)
            // data.settings.dataIsLoad = true
            // console.log('data transpiled', _.cloneDeep(data));
            if (data.settings) {
                this.props.dispatch(premiumActions.updatePremiumAndTrial(data))
                this.props.dispatch(settingsActions.updateSettings(data))
                setTimeout(() => {
                    this.getCaptionsClassnames()
                    this.startTextSlider()
                    this.initParallax()
                    this.addParallax()
                }, 0)

            }
            return
        }



        const compId = Wix.Utils.getCompId()
        const APP_NAME = 'impressive-text-slider-'.concat(compId);
        let lastDateUpdateResponse = await server.getLastDateUpdate()
        // console.log('lastDateUpdate response',lastDateUpdateResponse)
        if (lastDateUpdateResponse) {
            this.props.dispatch(premiumActions.updatePremiumAndTrial(lastDateUpdateResponse))

            if (lastDateUpdateResponse.newUser) {
                sessionStorage.setItem('new-user', Date.now())
                MixHelper.events.newUserAdded()
            }

            if (lastDateUpdateResponse.settings == null) {
                MixHelper.events.slideshowCreated()
            }
        }
        if (Wix.Utils.getViewMode() == 'editor') {
            try {
                const saleInfoResponse = await settingsServer.getSaleInfo()
                const { isSaleActive, usedCurrentSale, currentSaleId } = saleInfoResponse.data
                const watchedSale = localStorage.getItem(`showed-trial-add-sale-${currentSaleId}`) == 'true'
                if (isSaleActive && !watchedSale && !usedCurrentSale) {
                    this.setState({ showTrialAddSaleTooltip: true })
                }
            } catch (e) {
                console.error('error getting sale info', e)

            }
        }


        // получение данных из сессии нельзя ставить до асинхронного запроса, иначе при быстрых сменах настроек в settings
        // получаем устаревшие данные и перезатираем сессию в sessionStorageWidgetDataUpdate неправильными данными
        let storageData = JSON.parse(sessionStorage.getItem(APP_NAME))
        // console.log('storageData new',storageData.settings.slides.length,storageData);
        // если true, то при обновлении размеров виджета перезапишем и остальные настройки в сессии
        let sessionIsLoadFromDB = false

        if (storageData && storageData.settings) {
            let lastDateUpdate = 0

            if (lastDateUpdateResponse && lastDateUpdateResponse.settings && lastDateUpdateResponse.settings.lastDateUpdate) {
                lastDateUpdate = lastDateUpdateResponse.settings.lastDateUpdate
            }
            // if (data && data.settings && data.settings.lastDateUpdate) {
            //     lastDateUpdate = data.settings.lastDateUpdate
            // }
            // console.log('STORAGE!')
            // если настройки из БД более свежие, чем из сессии, то используем их
            if (storageData.settings.lastDateUpdate && storageData.settings.lastDateUpdate < lastDateUpdate) {
                let data = await server.getSettings()

                // storageData.settings = data.settings
                this.props.dispatch(settingsActions.updateSettings(data))
                sessionStorage.setItem(APP_NAME, JSON.stringify(data))
            } else {
                //PLACE TO ADD NEW UPDATE BANNERS AND COUPONS
                // применяем настройки из сессии
                this.props.dispatch(settingsActions.updateSettings(storageData))
                // сохраняю настройки премиума в сессию, чтобы использовать при открытии настроек
                storageData.isProfessionalPremium = lastDateUpdateResponse.isProfessionalPremium
                storageData.isSmartPremium = lastDateUpdateResponse.isSmartPremium
                storageData.userInTrialMode = lastDateUpdateResponse.userInTrialMode
                storageData.trialEndTime = lastDateUpdateResponse.trialEndTime
                storageData.isDeveloper = lastDateUpdateResponse.isDeveloper
                storageData.premiumForRateUsed = lastDateUpdateResponse.premiumForRateUsed
                storageData.trialReminderOverWatched = lastDateUpdateResponse.trialReminderOverWatched
                storageData.trialReminderTwoDaysWatched = lastDateUpdateResponse.trialReminderTwoDaysWatched
                storageData.countdownNotificationWatched = lastDateUpdateResponse.countdownNotificationWatched

                storageData.usedCoupon = lastDateUpdateResponse.usedCoupon
                storageData.usedCouponNY = lastDateUpdateResponse.usedCouponNY
                storageData.canUseCoupon = lastDateUpdateResponse.canUseCoupon

                storageData.newUpdatesFeb25Showed = lastDateUpdateResponse.newUpdatesFeb25Showed

                sessionStorage.setItem(APP_NAME, JSON.stringify(storageData))
            }
        } else {
            // console.log('reduc last date', _.cloneDeep(this.props.settingsReducer))
            let data = await server.getSettings()
            // console.log('server data text slider',data)
            if (data && data.settings) {
                // console.log('DB!')
                // console.log('this.props.settingsReducer',this.props.settingsReducer);

                const tempSettings = JSON.parse(sessionStorage.getItem('temp-settings-'.concat(compId)))
                if (tempSettings) {
                    // если сессия до перезагрузки была удалена, а настройки пришли, то они должны храниться в сессии во временном объекте
                    // const storageData = JSON.parse(sessionStorage.getItem('impressive-text-slider-'.concat(compId)))
                    data.settings = tempSettings
                    sessionStorage.removeItem('temp-settings-'.concat(compId))
                    // this.props.dispatch(settingsActions.updateSettings(storageData))
                } else {
                    // data.settings.version = 2
                    if (data.settings.version !== 3) {
                        // если предыдущая версия, то добавляем триальное время 1 раз,
                        // для этого вводим свойство trialWasAdded в триале в серверной части
                        let request = await server.addTrialAfterConvert(data.isProfessionalPremium || data.isSmartPremium)
                        // присваиваем сразу триал к настройкам, чтобы пользователь сразу знал,
                        //  что у него триал, а не надо было перезагружать страницу
                        if (request && request.data && request.data.trialWasAdded && request.data.userInTrialMode) {
                            data.trialEndTime = request.data.trialEndTime
                            data.userInTrialMode = request.data.userInTrialMode
                        }
                    }

                    // конвертация для обратной совместимости
                    data.settings = transpileSettings(data.settings)
                }
                // сохраняю для передачи в функцию, которая сохранит размеры виджета
                storageData = data
                sessionIsLoadFromDB = true

                this.props.dispatch(settingsActions.updateSettings(data))
                data.settings.dataIsLoad = true
                sessionStorage.setItem(APP_NAME, JSON.stringify(data))
            }

            if (data && data.settings == null) {
                MixHelper.events.firstAdded()
            }
        }
        setTimeout(() => {
            const deviceType = Wix.Utils.getDeviceType();
            // console.log('init slider timeout 0 deviceType', deviceType)
            if (deviceType != this.props.settingsReducer.deviceType) {
                this.props.dispatch(settingsActions.changeDeviceType(deviceType))
            }
            this.sessionStorageWidgetDataUpdate(APP_NAME, storageData, sessionIsLoadFromDB, lang, locale)
            // инициализация слайдера должна быть после всех диспатчей
            this.getCaptionsClassnames()
            this.startTextSlider()
            this.initParallax()

            this.addParallax()

        }, 0)
    }

    initParallax() {
        const settingsReducer = this.props.settingsReducer;
        const deviceType = Wix.Utils.getDeviceType();
        const parallaxType = this.props.settingsReducer.parallaxType
        let parallaxImage = utils.convertParallaxImage(
            settingsReducer.parallaxImage[0],
            settingsReducer.widgetDimensions.editedWidth,
            settingsReducer.widgetDimensions.editedHeight,
            window.innerWidth,
            this.getSliderVerticalHeight(),
            deviceType === 'mobile'
        )

        if (deviceType === 'mobile' && settingsReducer.widgetDimensions.editedWidthMobile) {
            parallaxImage = utils.convertParallaxImage(
                settingsReducer.parallaxImage[0],
                settingsReducer.widgetDimensions.editedWidthMobile,
                settingsReducer.widgetDimensions.editedHeightMobile,
                window.innerWidth,
                this.getSliderVerticalHeight(),
                deviceType === 'mobile'
            )
        }

        const widgetDimensions = {
            width: window.innerWidth,
            height: this.getSliderVerticalHeight()
        };

        const imgDims = getImageDimensions(widgetDimensions, { width: parallaxImage.width, height: parallaxImage.height })
        const centerPoint = calculateCenterPointFromAbsolute(
            {
                transformX: parallaxImage.offsetX,
                transformY: parallaxImage.offsetY
            },
            {
                width: widgetDimensions.width,
                height: widgetDimensions.height
            },
            {
                width: imgDims.width,
                height: imgDims.height
            },
            parallaxImage.scale * 100
        )

        if (parallaxImage.scale == 1 && (parallaxType == 'pan-left' || parallaxType == 'pan-right')) {
            const newOffsets = calculateAbsoluteFromCenterPoint(
                centerPoint,
                {
                    width: widgetDimensions.width,
                    height: widgetDimensions.height
                },
                {
                    width: imgDims.width,
                    height: imgDims.height
                },
                1.5 * 100
            )
            parallaxImage.scale = 1.5
            parallaxImage.offsetX = newOffsets.transformX
            parallaxImage.offsetY = newOffsets.transformY
        }
        // console.log(parallaxImage)
        this.setState({
            parallaxImage: parallaxImage
        });
    }


    getSliderStyle(settings, deviceType) {
        const mobile = deviceType === 'mobile'
        const viewMode = this.state.viewMode || Wix.Utils.getViewMode()
        const widgetWidth = this.props.settingsReducer.widgetDimensions.editedWidth
        let borderRadius = '50%'
        let border = 'none'
        let borderWidth = mobile ? (settings.dotsSize * (window.innerWidth / widgetWidth)) / 5 : settings.dotsSize / 5
        let backgroundColor = settings.dotsColor
        let height = mobile ? 8 : settings.dotsSize

        const { settingsCorrectedToPremium } = getSettingsCorrectedToPremium(this.props.settingsReducer, viewMode, this.props.premiumReducer)

        const dotsDesign = settingsCorrectedToPremium.dotsDesign

        switch (dotsDesign) {
            case 'squared':
                borderRadius = '0px'
                break;
            case 'circle-solid':
                borderRadius = '50%'
                break;
            case 'circle-stroke':
                borderRadius = '50%'
                border = `${borderWidth}px solid ${settings.dotsColor}`
                backgroundColor = 'transparent'
                break;
            case 'rect':
                height = height / 3
                borderRadius = '3px'
                break;
        }


        let propsForSliderContainer = {
            dotsColor: backgroundColor,
            dotsColorActive: settings.activeDotsColor,
            dotsSize: settings.dotsSize,
            dotsHeight: height,
            dotsSpacing: settings.dotsSpacing,
            dotsColorHover: settings.hoverDotsColor,
            dotsBorderRadius: borderRadius,
            dotsBorder: border,
            dotsMargin: 5,
            hasNavigationOnHover: settings.hasNavigationOnHover,

            arrowScale: 1,
            prevArrowMargin: 10,
            nextArrowMargin: 10,
        }
        if (this.props.settingsReducer.sliderMode === "vertical") {
            propsForSliderContainer.prevArrowMargin = 'none'
        }

        if (deviceType === 'mobile') {
            propsForSliderContainer.dotsSize = 8
            // для мобильного вида ставим нерегулируемое расстояние между точками
            propsForSliderContainer.dotsSpacing = 0//12
            propsForSliderContainer.arrowScale = 0.5
            propsForSliderContainer.prevArrowMargin = 0
            propsForSliderContainer.nextArrowMargin = 0
            propsForSliderContainer.dotsMargin = 0
        }

        return propsForSliderContainer
    }


    // получаем размеры виджета с учётом точек переключения слайдов
    // вызывается при инициализации слайдера
    // проверяем чтобы размеры виджета в редаксе были актуальные
    async sessionStorageWidgetDataUpdate(APP_NAME, storageData, sessionIsLoadFromDB, lang, locale) {
        const dataName = 'widget-data-'.concat(Wix.Utils.getCompId());
        const settingsFromStorage = sessionStorage.getItem(dataName)
        const prevWidgetData = settingsFromStorage === 'undefined' ? null : JSON.parse(sessionStorage.getItem(dataName))
        let newData = {}

        if (prevWidgetData) {
            newData = {
                width: prevWidgetData.width,
                height: prevWidgetData.height,
                mobileWidth: prevWidgetData.mobileWidth,
                mobileHeight: prevWidgetData.mobileHeight,
                deviceType: prevWidgetData.deviceType,
            }

            // console.log('sessionStorageWidgetDataUpdate this.state.deviceType', this.state.deviceType)

            switch (this.state.deviceType) {
                case 'desktop':
                    newData.width = window.innerWidth
                    newData.height = this.getSliderVerticalHeight()
                    newData.deviceType = 'desktop'
                    break;

                case 'mobile':
                    newData.mobileWidth = window.innerWidth
                    newData.mobileHeight = this.getSliderVerticalHeight()
                    newData.deviceType = 'mobile'
                    break;
            }
        } else {
            newData = {
                width: storageData.settings.widgetDimensions.width,
                height: storageData.settings.widgetDimensions.height,
                mobileWidth: storageData.settings.widgetDimensions.mobileWidth,
                mobileHeight: storageData.settings.widgetDimensions.mobileHeight,
                deviceType: 'desktop',
            }
            switch (this.state.deviceType) {
                case 'desktop':
                    newData.width = window.innerWidth
                    newData.height = this.getSliderVerticalHeight()
                    newData.deviceType = 'desktop'
                    break;

                case 'mobile':
                    newData.mobileWidth = window.innerWidth
                    newData.mobileHeight = this.getSliderVerticalHeight()
                    newData.deviceType = 'mobile'
                    break;
            }
        }
        newData.lang = lang
        this.props.dispatch(settingsActions.addLanguageToCaptions({ lang, locale }))

        const updatedDimensions = { ...storageData.settings.widgetDimensions, ...newData }
        const isEqual = _.isEqual(storageData.settings.widgetDimensions, updatedDimensions)
        // если изменились значения размеров, то диспатчим
        if (!isEqual) {
            this.props.dispatch(settingsActions.changeWidgetDimansion(newData))
        }
        if (sessionIsLoadFromDB) {
            // если данные загружены из БД, то берём эти данные
            storageData.settings.widgetDimensions = { ...storageData.settings.widgetDimensions, ...newData }
        } else {
            // если данные используются из сессии, то берём данные из сессии посвежее
            let currentSessionSettings = JSON.parse(sessionStorage.getItem('impressive-text-slider-'.concat(Wix.Utils.getCompId())))
            currentSessionSettings.settings.widgetDimensions = { ...currentSessionSettings.settings.widgetDimensions, ...newData }
            storageData.settings = currentSessionSettings.settings
        }

        storageData.settings = setLanguageSettingsToCaptions(storageData.settings, lang, locale)

        sessionStorage.setItem(dataName, JSON.stringify(newData))
        sessionStorage.setItem(APP_NAME, JSON.stringify(storageData))
    }

    getArrowsHtml(position = 'left') {
        if (this.props.settingsReducer.selectedArrowsDesign == ARROWS_DESIGN.legacy || this.props.settingsReducer.selectedArrowsDesign == undefined) {
            return ``
        }
        const arrow = vectorArrowsArray[this.props.settingsReducer.customArrows]

        const size = this.props.settingsReducer.customArrowsSettings.size
        const margin = this.props.settingsReducer.customArrowsSettings.margin

        const commonStyleSvg = {
            width: `${size}px`,
            height: `${size}px`
        }
        const isArrowsVertical = this.props.settingsReducer.sliderMode === 'vertical'


        return `
            <div
                style="
                    position: fixed;
                    top: calc(50% ${isArrowsVertical ? `+ ${position === 'left' ? margin : -margin}px` : ''});
                    transform: translateY(-50%) ${isArrowsVertical ? `translateX(-50%)` : ''};
                    left: ${isArrowsVertical ? '50%' : position == 'left' ? `${margin - 15}px` : ''};
                    right: ${isArrowsVertical ? '' : position == 'right' ? `${margin - 15}px` : ''};
                    width: ${commonStyleSvg.width}; 
                    height: ${commonStyleSvg.height};
                "
            >
                <svg 
                class="svg-arrow" 
                style="
                    display: block; 
                    width: ${commonStyleSvg.width}; 
                    height: ${commonStyleSvg.height}; 
                    transform: ${position == 'left' ? `scaleX(-1) rotate(${isArrowsVertical ? -90 : 0}deg) translateY(${isArrowsVertical ? 0 : 0}px)` : `rotate(${isArrowsVertical ? 90 : 0}deg)`};
                " 
                viewBox="${arrow.viewbox}"
                >
                    ${arrow.path.map((path, pathIndex) => {
            let svgFill = arrow.fillRule == 'fillFirst' && pathIndex > 0 ? '#fff' : ''
            if (arrow.fillRule == 'stroke') {
                svgFill = 'none'
            }
            return `
                                <path
                                    fill="${svgFill}"
                                    fill-rule="${arrow.fillRule == 'evenodd' ? 'evenodd' : ''}"
                                    stroke-width="${arrow.fillRule == 'stroke' || arrow.fillRule == 'stroke-fill' ? arrow.strokeWidth : 0}"
                                    d="${path}"
                                />
                            `
        })
            }
                </svg>
            </div>
        `
    }

    startTextSlider() {
        const viewMode = this.state.viewMode || Wix.Utils.getViewMode()
        const { settingsCorrectedToPremium, settingsWasChangedInCorrectToPremuim } = getSettingsCorrectedToPremium(this.props.settingsReducer, viewMode, this.props.premiumReducer)
        const slides = getVisibleSlides(settingsCorrectedToPremium.slides)
        // const slides = this.getVisibleSlides(settingsCorrectedToPremium.slides)
        // const slides = this.getVisibleSlides(this.props.settingsReducer.slides)
        if (slides.length > 0) {
            const isMobile = Wix.Utils.getDeviceType() === 'mobile'
            const pauseDuration = settingsCorrectedToPremium.pauseDuration > 1000 ? Math.round(settingsCorrectedToPremium.pauseDuration) : 1000;
            const captionPlayMode = settingsCorrectedToPremium.captionPlayMode
            const hasDots = isMobile ? (settingsCorrectedToPremium.hasDots && settingsCorrectedToPremium.hasMobileDots) : settingsCorrectedToPremium.hasDots
            // слайдер не терпит изменения стейта и пропсов, если изменение произошло - он слетает
            // если вызывать слайдер при didUpdate, то слайдеры накладываются друг на друга и начинается заново
            // для взаимодействия со слайдером поэтому использую this вместо this.state
            this.lightSlider = $('#lightslider').lightSlider({
                auto: true,
                loop: true,
                mode: settingsCorrectedToPremium.animationMode,
                item: 1,
                enableDrag: (settingsCorrectedToPremium.disableDrag || slides.length <= 1) ? false : true,
                enableTouch: (settingsCorrectedToPremium.disableDrag || slides.length <= 1) ? false : true,
                vertical: (settingsCorrectedToPremium.sliderMode === 'vertical' && settingsCorrectedToPremium.animationMode !== 'none' && !isMobile) ? true : false,
                verticalHeight: this.getSliderVerticalHeight(),
                pager: hasDots,
                speed: settingsCorrectedToPremium.animationMode === 'none' ? 0 : settingsCorrectedToPremium.slideAnimationSpeed,
                easing: 'cubic-bezier(.08,.62,.96,.39)',
                slideMargin: 0,
                controls: settingsCorrectedToPremium.hasArrows && this.state.deviceType === 'desktop',
                prevHtml: this.getArrowsHtml('left'),
                nextHtml: this.getArrowsHtml('right'),
                onBeforeStart: () => {
                    slides.map((slide, slideIndex) => {
                        this.showAllNonAnimateCaptions(slideIndex, slides)
                    })
                },
                onSliderLoad: (el) => {
                    this.lightSlider.pause()
                    this.currentSlide = el.getCurrentSlideCount() - 1
                    this.slideWrapperElement = document.querySelector('.lSSlideWrapper')

                    const slidesArray = document.getElementById('lightslider').children

                    for (let i = 0; i < slidesArray.length; i++) {
                        if (slidesArray[i].className.match('.clone')) {
                            const cloneCaptions = slidesArray[i].firstChild.children
                            for (let y = 0; y < cloneCaptions.length; y++) {
                                // чтобы капчи были видны при смене слайда на клонированном слайде,
                                // который появляется на долю секунды, когда у них нет анимации появления
                                if (cloneCaptions[y].getAttribute('data-animation-in') === 'none') {
                                    cloneCaptions[y].style.opacity = 1
                                } else {
                                    cloneCaptions[y].style.opacity = 0
                                }
                            }
                        }
                    }
                    // const captions = slides[this.currentSlide].captions
                    let captions = this.getSlideCaption(slides[this.currentSlide], settingsCorrectedToPremium)
                    captions = getCaptionsAdaptedToTypingAnimation(_.cloneDeep(captions))

                    nextSlideHook(this.currentSlide)
                    configAnimations({
                        captions,
                        captionPlayMode: captionPlayMode,
                        slideIndex: this.currentSlide,
                        deviceType: this.state.deviceType,
                        pauseDuration: pauseDuration,
                        callback: (slideIndex) => this.goToNextSlide(slideIndex),
                        unicalClassName: '',
                        // unicalClassName: 'moved', 
                        getHoverState: this.getHoverState.bind(this),
                        pauseOnHover: settingsCorrectedToPremium.animationsOnHover,
                        getAnimationIsActive: () => true,
                        slideMomentId: Date.now()
                    })
                },

                onBeforeSlide: (el) => {
                    this.lightSlider.pause()
                    if (el.getCurrentSlideCount() === 0) {
                        this.currentSlide = slides.length - 1
                    } else {
                        this.currentSlide = el.getCurrentSlideCount() - 1
                    }
                    // перед началом прокрутки к следующему слайду скрываем капчи, если есть анимация появления
                    // или показываем, если её нет
                    this.showAllNonAnimateCaptions(this.currentSlide, slides)
                },
                onAfterSlide: (el) => {
                    this.stopAllCaptions(slides)
                    nextSlideHook(this.currentSlide)
                    this.lightSlider.pause()
                    let captions = this.getSlideCaption(slides[this.currentSlide], settingsCorrectedToPremium)
                    captions = getCaptionsAdaptedToTypingAnimation(_.cloneDeep(captions))

                    configAnimations({
                        captions,
                        captionPlayMode: captionPlayMode,
                        slideIndex: this.currentSlide,
                        deviceType: this.state.deviceType,
                        pauseDuration: pauseDuration,
                        callback: (slideIndex) => this.goToNextSlide(slideIndex),
                        unicalClassName: '',
                        getHoverState: this.getHoverState.bind(this),
                        pauseOnHover: settingsCorrectedToPremium.animationsOnHover,
                        getAnimationIsActive: () => true,
                        slideMomentId: Date.now()
                    })
                    this.captionAnimated = false
                    this.curentCaptionIndex = null

                },
                onBeforeNextSlide: (el) => {
                    // если запущена демонстрация и когда проигрались все капчи на последнем слайде
                    // останавливаем демонстрацию и возвращаем текущие настройки
                    if (settingsCorrectedToPremium.demoIsShow && el.getCurrentSlideCount() === slides.length) {
                        this.props.dispatch(settingsActions.stopShowTemplate())
                    }
                },
                onBeforePrevSlide: (el) => {

                }
            })

            this.setNavigationStyle(settingsCorrectedToPremium)
            this.setPagesStyle()
        }
    }

    // получить капчи для слайдера, у которых убрана задержка перед анимацией для captionPlayMode !== 'delay' 
    // для настроек после конвертации с версии 2, когда пользователь ещё не редактировал слайд
    getSlideCaption(slide, settingsCorrectedToPremium) {
        let captions = _.cloneDeep(slide.captions)
        // в старых настройках пауза перед появлением и исчезновением работала только при captionPlayMode === 'delay' 
        // поэтому отключаем задержки перез анимацией капч, если слайд ещё не редактировался 
        // в эдиторе после конвертиции настроек на новые
        if (slide.slideJustTranspiled) {
            captions = captions.map(caption => {
                if (settingsCorrectedToPremium.captionPlayMode !== 'delay') {
                    caption.delayIn = 0
                    caption.delayOut = 0
                }
                return caption
            })
        }
        return captions

    }

    refreshCreditCaption(className, slideIndex) {
        const slideHMTLElement = document.querySelector(`.slide-container-${slideIndex}:not(.clone)`) || document
        const captionElement = slideHMTLElement.querySelector(className)
        const textElems = captionElement.querySelectorAll('.credits-content')
        for (let item of textElems) {
            item.style.transition = 'none'
            item.style.filter = ``
            item.style.opacity = ``
            item.style.transform = ``
            setTimeout(() => {
                item.style.transition = ``
            }, 5)
        }
    }

    refreshCountdownCaption(className, slideIndex) {
        const slideHMTLElement = document.querySelector(`.slide-container-${slideIndex}:not(.clone)`) || document
        const captionElement = slideHMTLElement.querySelector(className)
        if (captionElement) {
            const listElement = captionElement.querySelector('.countdown-list')
            listElement.style.transition = 'none'
            listElement.style.top = 0
        }
    }

    refreshCountdownCubeCaption(className, slideIndex) {
        // console.log('cube')
        const slideHMTLElement = document.querySelector(`.slide-container-${slideIndex}:not(.clone)`) || document
        const captionElement = slideHMTLElement.querySelector(className)
        const listElement = captionElement.querySelector('.countdown-list')
        listElement.style.transition = 'none'
        listElement.style.transform = `rotateX(0deg)`
        setTimeout(() => {
            listElement.style.transition = ''
        }, 5)
        const listElementsArray = listElement.querySelectorAll('.contdown-item')
        for (let item of listElementsArray) {
            item.style.visibility = ''
        }
        listElementsArray[0].style.visibility = 'visible'
    }

    showAllNonAnimateCaptions(slideIndex, slides) {

        slides[slideIndex].captions.map((caption, captionIndex) => {
            if (caption.animationIn === 'none' || caption.boxId != '' || caption.animationIn.includes('countdown') || caption.animationIn === 'stripes' || caption.animationIn.includes('credits')) {
                // чтобы капчи были видны при смене слайда, когда у них нет анимации появления
                // console.log('captionIndex',captionIndex)
                $(`.caption-${slideIndex}-${caption.index}`).css({ opacity: 1 });
                if (caption.animationIn.includes('credits')) {
                    this.refreshCreditCaption(`.caption-${slideIndex}-${caption.index}`, slideIndex)
                }
                if (caption.animationIn.includes('countdown')) {
                    if (caption.animationIn.includes('Cube')) {
                        this.refreshCountdownCubeCaption(`.caption-${slideIndex}-${caption.index}`, slideIndex)
                    } else {
                        this.refreshCountdownCaption(`.caption-${slideIndex}-${caption.index}`, slideIndex)
                    }
                }
                if (caption.type === 'text' && caption.animationIn === 'none') {

                    // для текста необходимо перебить импортантами слили textillate, чтобы был виден текст
                    // если у текста есть анимация исчезания, то удаляем этот класс в animationsConfiger.js
                    $(`.caption-${slideIndex}-${caption.index}`).addClass("showTextAnyway");
                    if (caption.animationOut !== 'none') {

                        // если у текста нет анимации появления, но есть анимация исчезновения, то возникает проблема с отображением текста
                        // textillate добавляет видимость беквам при анимации появления и убирает при анимации исчезновения
                        // соответственно если анимации появления нет, то буквы остаются с visibility === 'hidden'
                        // использование анимации с названием 'none' или установка delay = 0 в animationConfig успеха не принесли
                        // поэтому перед инициализацией анимации капч на слайде ищем текстовые капчи без анимации появления
                        // и ставим всем буквам visibility = 'visible'. При анимации исчезновения textillate сам делает их невидимыми в необходимом порядке
                        const captionElementsList = document.querySelectorAll(`.caption-${slideIndex}-${caption.index}`)
                        for (const captionElement of captionElementsList) {
                            const charList = captionElement.querySelectorAll('span')
                            for (const char of charList) {
                                if (char.style.visibility === 'hidden') {
                                    char.style.visibility = 'visible'
                                }
                            }
                        }
                    }
                }
            } else {
                // а когда нет анимации появления, чтобы не моргали (это относится не к тексту)
                $(`.caption-${slideIndex}-${caption.index}`).css({ opacity: 0 });
            }
        })
    }


    goToNextSlide(slideIndex) {
        if (this.currentSlide === slideIndex) {
            this.lightSlider.play()
        }
    }

    stopAllCaptions(slides) {
        slides.map((slide, slideIndex) => {
            slide.captions.map(caption => {
                if (caption.boxId === '' && !caption.animationIn.includes('countdown') && caption.animationIn !== 'stripes' && !caption.animationIn.includes('credits')) {
                    $(`.caption-${slideIndex}-${caption.index}`).css({ opacity: 0 });
                    if (caption.type === 'text' && caption.animationIn !== 'typing') {
                        $(`.caption-${slideIndex}-${caption.index}`).textillate('stop')
                    }
                } else if (caption.animationIn === 'countdownUp' || caption.animationIn === 'countdownDown') {
                    const captionElements = document.querySelectorAll(`.caption-${slideIndex}-${caption.index}`)
                    for (let i = 0; i < captionElements.length; i++) {
                        // чтобы на второй итерации цикла слайдов элемент появился с текстом первой строки
                        const listElement = captionElements[i].querySelector('.countdown-list')
                        listElement.style.transition = 'none'
                        listElement.style.transform = `translateY(0)`
                    }
                }
            })
        })
    }

    setNavigationStyle(settingsCorrectedToPremium) {
        const isCustomArrows = this.props.settingsReducer.selectedArrowsDesign == ARROWS_DESIGN.vector
        if (isCustomArrows) {
            return
        }
        const arrowId = settingsCorrectedToPremium.arrows + 1
        $('.lSPrev').attr('id', 'a' + arrowId);
        $('.lSNext').attr('id', 'a' + arrowId);
    }

    // стили для точек пагинации
    setPagesStyle() {
        if (this.props.settingsReducer.hasDots) {
            // console.log("Has dots, device type: ", this.state.deviceType, " dotsType: ", this.props.settingsReducer.dotsType);
            if (this.state.deviceType === 'mobile' && !this.props.settingsReducer.hasMobileDots) {
                // если в мобильной версии точки отключены, то никиакие стили уже не потребуются
                return
            }
            if (this.props.settingsReducer.dotsType === 'inner') {
                // console.log("Inner");
                $('.lSPager').css({
                    position: 'relative',
                    top: `${-15 - this.state.sliderStyle.dotsSize}px`
                })
            } else if (this.state.deviceType === 'mobile') {
                $('.lSPager').css({
                    marginTop: 0,
                    display: 'flex',
                    justifyContent: 'space-around'
                })
            }
        }
    }

    getHoverState() {
        return this.stopAnimateCaptions
    }

    stopAnimationsOnHover() {
        // предотвращаем анимацию исчезновения капч
        if (!this.stopAnimateCaptions) {
            this.stopAnimateCaptions = true
        }
    }

    playAnimationsOnHover(slides) {
        // разрешаем анимацию исчезновения капч
        if (this.stopAnimateCaptions) {
            this.stopAnimateCaptions = false
        }
    }

    getSliderVerticalHeight() {
        let height = window.innerHeight
        const mobileDotsSize = 8
        const hasDots = this.props.settingsReducer.hasDots;
        const dotsType = this.props.settingsReducer.dotsType;
        if (hasDots && dotsType === 'outer') {
            if (this.state.deviceType === 'mobile') {
                // на мобильной версии точки можно выключать отдельно от десктопной
                height = this.props.settingsReducer.hasMobileDots ? (height - 10 - mobileDotsSize) : height
            } else {
                height = height - 15 - this.props.settingsReducer.dotsSize
            }
        }
        return height
    }


    getCaptionsClassnames() {
        let captionsClassnames = []
        let captionContainersClassnames = []
        getVisibleSlides(this.props.settingsReducer.slides).map((slide, slideIndex) => {
            if (captionContainersClassnames[slideIndex] === undefined) {
                captionContainersClassnames[slideIndex] = [];
            }
            if (captionsClassnames[slideIndex] === undefined) {
                captionsClassnames[slideIndex] = [];
            }

            slide.captions.map((caption, captionIndex) => {
                captionsClassnames[slideIndex][captionIndex] = `caption-${slideIndex}-${captionIndex}`
                captionContainersClassnames[slideIndex][captionIndex] = `caption-container-${slideIndex}-${captionIndex}`
            })
        })
        this.captionsClassnames = captionsClassnames
        this.captionContainersClassnames = captionContainersClassnames
    }

    addParallax() {
        const showParallax = this.props.settingsReducer.backgroundType == 'preset' || this.props.settingsReducer.backgroundType == 'image' || (this.props.settingsReducer.hasParallax && this.props.settingsReducer.backgroundType != 'none')
        if (showParallax && this.state.deviceType != 'mobile') {
            const slider = document.querySelector('.parallaxBackground');
            const backgroundImageSize = slider.getBoundingClientRect();
            const parallaxImage = _.cloneDeep(this.state.parallaxImage)
            const widgetDimensions = {
                width: window.innerWidth,
                height: this.getSliderVerticalHeight()
            };
            const centralPoint = {
                x: widgetDimensions.width / 2,
                y: widgetDimensions.height / 2
            };

            // console.log('addParallax - widgetDimensions: ', widgetDimensions)
            // console.log('addParallax - centralPoint: ', centralPoint)
            // console.log('addParallax - parallaxImage: ', parallaxImage)
            const sensivity = this.props.settingsReducer.sensivity === undefined ? 0.2 : (this.props.settingsReducer.sensivity / 100)
            let backgroundPresetEvenPaths = []
            let backgroundPresetOddPaths = []
            const usePreset = this.props.settingsReducer.backgroundType == 'preset'
            const imgDims = getImageDimensions({ width: window.innerWidth, height: window.innerHeight }, { width: parallaxImage.width, height: parallaxImage.height })
            const centerPoint = calculateCenterPointFromAbsolute(
                {
                    transformX: parallaxImage.offsetX,
                    transformY: parallaxImage.offsetY
                },
                {
                    width: widgetDimensions.width,
                    height: widgetDimensions.height
                },
                {
                    width: imgDims.width,
                    height: imgDims.height
                },
                parallaxImage.scale * 100
            )
            // for (let oddPath of backgroundPresetOddPaths) {
            //     oddPath.style.transition = '.3s'
            // }
            // for (let evenPath of backgroundPresetEvenPaths) {
            //     evenPath.style.transition = '.55s'
            // }
            switch (this.props.settingsReducer.parallaxType) {
                case 'mouse':
                    window.addEventListener('mousemove', (e) => {

                        const step = {
                            x: (parallaxImage.offsetX - (e.pageX - centralPoint.x) * sensivity),
                            y: (parallaxImage.offsetY - (e.pageY - centralPoint.y) * sensivity),
                        };

                        const backgroundImageHeight = widgetDimensions.width / parallaxImage.width * parallaxImage.height
                        const equalX =
                            backgroundImageSize.width * parallaxImage.scale + step.x > widgetDimensions.width
                            &&
                            step.x < 0;
                        const equalY = backgroundImageHeight * parallaxImage.scale + step.y > widgetDimensions.height
                            &&
                            step.y < 0;

                        // console.log('parallax mousemove - backgroundImageHeight: ', backgroundImageHeight)
                        // console.log(`parallax mousemove - equalX equalY: ${equalX}, ${equalY}`)
                        if (usePreset) {
                            $(`.parallaxBackground > svg > g > *:not(.immutable)`).css('transform', `translateX(${- (e.pageX - centralPoint.x) * sensivity}px) translateY(${- (e.pageY - centralPoint.y) * sensivity}px)`)
                        } else {
                            if (equalX) {
                                dynamics.css(slider, {
                                    backgroundPositionX: `${(step.x)}px`,
                                    transition: '.15s'
                                });

                            }
                            if (equalY) {
                                dynamics.css(slider, {
                                    backgroundPositionY: `${(step.y)}px`,
                                    transition: '.15s'
                                });
                            }
                        }

                    });

                    window.addEventListener('mouseup', e => {
                        if (usePreset) {
                            $(`.parallaxBackground > svg > g > *:not(.immutable)`).css('transform', `translateX(${0}px) translateY(${0}px)`)
                        } else {
                            dynamics.stop(slider);

                            dynamics.css(slider, {
                                backgroundPositionX: `${(parallaxImage.offsetX)}px`,
                                backgroundPositionY: `${(parallaxImage.offsetY)}px`,
                                transition: '.5s'
                            });
                        }
                    })

                    break;

                case 'none':


                    break;

                case 'fade-in':
                    let breakpointFadeIn = 100;

                    if (usePreset) {

                        $(`.parallaxBackground g *`).css('opacity', `0`)
                    } else {
                        slider.style.opacity = 0;
                    }
                    Wix.addEventListener(Wix.Events.SCROLL, (data) => {
                        if (data.scrollTop + data.documentHeight > data.y - breakpointFadeIn) {
                            // const diff = data.y > data.documentHeight ? data.y - data.scrollTop - data.documentHeight : -data.scrollTop - breakpointReveal;
                            const diff = data.y < data.documentHeight ?
                                remapValue(data.scrollTop, 0, Math.max(data.y + data.height / 2 - data.documentHeight / 2, 1), 0, 1) :
                                remapValue(data.scrollTop, data.y - data.documentHeight - breakpointFadeIn, data.y + data.height / 2 - data.documentHeight / 2, 0, 1)


                            // console.log('parallax Wix.Events.SCROLL - step: ', step)
                            // console.log('parallax Wix.Events.SCROLL - hasSpace: ', hasSpace)
                            // console.log('parallax Wix.Events.SCROLL - moreThanNull: ', moreThanNull)
                            if (usePreset) {
                                $(`.parallaxBackground g *`).css('opacity', `${diff}`)
                            } else {
                                dynamics.stop(slider);
                                dynamics.css(slider, {
                                    opacity: `${diff}`,
                                    transition: '.2s',
                                });
                            }

                        }
                    });
                    break;
                case 'reveal':
                    let breakpointReveal = -250;
                    Wix.addEventListener(Wix.Events.SCROLL, (data) => {
                        if (data.scrollTop + data.documentHeight > data.y) {
                            const diff = data.y > data.documentHeight ? data.y - data.scrollTop - data.documentHeight + data.height / 2 : -data.scrollTop - breakpointReveal;
                            // const diff = remapValue(data.scrollTop, data.y - data.documentHeight / 2 + data.height / 2, data.y + data.height, -1, 1)
                            // console.log('diff -', diff)
                            // console.log('data.y - data.documentHeight / 2 + data.height / 2', data.y - data.documentHeight / 2 + data.height / 2)
                            // console.log('data.y + data.documentHeight / 2 + data.height / 2', data.y + data.documentHeight / 2 + data.height / 2)
                            const backgroundImageHeight = widgetDimensions.width / parallaxImage.width * parallaxImage.height
                            // const step = parallaxImage.offsetY - diff * backgroundImageHeight * parallaxImage.scale
                            const step = diff + this.props.settingsReducer.parallaxImage[0].offsetY
                            const hasSpace = Math.abs(step) < backgroundImageHeight * parallaxImage.scale - widgetDimensions.height && step < 0
                            const moreThanNull = step < 0

                            // console.log('parallax Wix.Events.SCROLL - step: ', step)
                            // console.log('parallax Wix.Events.SCROLL - hasSpace: ', hasSpace)
                            // console.log('parallax Wix.Events.SCROLL - moreThanNull: ', moreThanNull)
                            if (moreThanNull) {

                                if (hasSpace) {
                                    dynamics.stop(slider);
                                    dynamics.css(slider, {
                                        backgroundPositionY: `${step}px`,
                                        transition: '.25s',
                                    });
                                } else {
                                    dynamics.stop(slider);
                                    dynamics.css(slider, {
                                        backgroundPositionY: `${-(backgroundImageHeight * parallaxImage.scale - widgetDimensions.height)}px`,
                                        transition: '.1s',
                                    });

                                }
                            }
                        }
                    });
                    break;
                case 'pan-right':
                    const backgroundImageWidthPR = widgetDimensions.width * parallaxImage.scale
                    const availableSpacePR = usePreset ? 200 : (backgroundImageWidthPR - widgetDimensions.width) / parallaxImage.scale
                    const maxTransformPR = -availableSpacePR
                    if (usePreset) {
                        // $(`.parallaxBackground > svg > g > *:not(.immutable)`).css('transform', `translateX(${maxTransformPR}px)`)
                    } else {
                        // dynamics.stop(slider);
                        // dynamics.css(slider, {
                        //     backgroundPositionX: `${maxTransformPR}px`,
                        //     transition: 'none'
                        // });
                    }
                    let breakpointPanRight = 0;
                    Wix.addEventListener(Wix.Events.SCROLL, (data) => {
                        if (data.scrollTop + data.documentHeight > data.y) {
                            const diff = data.y < data.documentHeight ?
                                remapValue(data.scrollTop, 0, data.documentHeight / 2, 0, 1) :
                                remapValue(data.scrollTop, data.y - data.documentHeight - breakpointPanRight, data.y + data.height / 2 - data.documentHeight / 2, 0, 1)
                            // const backgroundImageHeight = widgetDimensions.width / parallaxImage.width * parallaxImage.height
                            const backgroundImageWidth = widgetDimensions.width * parallaxImage.scale

                            const availableSpaceForImage = Math.abs(parallaxImage.offsetX)
                            const availableSpace = usePreset ? 300 : availableSpaceForImage
                            const step = -diff * availableSpace * sensivity
                            const stepClamped = step
                            // const hasSpace = Math.abs(step) < backgroundImageWidth * parallaxImage.scale - widgetDimensions.width && step < 0
                            const hasSpace = true
                            // const moreThanNull = step < 0
                            const moreThanNull = true
                            // console.log('parallax Wix.Events.SCROLL - step: ', step)
                            // console.log('parallax Wix.Events.SCROLL - diff: ', diff)
                            // console.log('parallax Wix.Events.SCROLL - hasSpace: ', hasSpace)
                            // console.log('parallax Wix.Events.SCROLL - moreThanNull: ', moreThanNull)
                            if (moreThanNull) {

                                if (hasSpace) {
                                    if (usePreset) {
                                        $(`.parallaxBackground > svg > g > *:not(.immutable)`).css('transform', `translateX(${-stepClamped}px)`)
                                    } else {
                                        dynamics.stop(slider);
                                        dynamics.css(slider, {
                                            backgroundPositionX: `${parallaxImage.offsetX - stepClamped}px`,
                                            transition: '.25s',
                                        });
                                    }
                                } else {
                                    dynamics.stop(slider);
                                    dynamics.css(slider, {
                                        backgroundPositionX: `${(backgroundImageWidth * parallaxImage.scale - widgetDimensions.width)}px`,
                                        transition: '.1s',
                                    });

                                }
                            }
                        }
                    });
                    break;
                case 'pan-left':
                    let breakpointPanLeft = 0;

                    const maxTransformPL = 0
                    if (usePreset) {
                        // $(`.parallaxBackground > svg > g > *:not(.immutable)`).css('transform', `translateX(${maxTransformPL}px)`)
                    } else {
                        // dynamics.stop(slider);
                        // dynamics.css(slider, {
                        //     backgroundPositionX: `${maxTransformPL}px`,
                        //     transition: 'none'
                        // });
                    }
                    Wix.addEventListener(Wix.Events.SCROLL, (data) => {
                        if (data.scrollTop + data.documentHeight > data.y) {
                            const diff = data.y < data.documentHeight ?
                                remapValue(data.scrollTop, 0, data.documentHeight / 2, 0, 1) :
                                remapValue(data.scrollTop, data.y - data.documentHeight - breakpointPanLeft, data.y + data.height / 2 - data.documentHeight / 2, 0, 1)
                            // const backgroundImageHeight = widgetDimensions.width / parallaxImage.width * parallaxImage.height
                            const backgroundImageWidth = widgetDimensions.width * parallaxImage.scale
                            const availableSpaceForImage = backgroundImageWidth - (Math.abs(parallaxImage.offsetX) + widgetDimensions.width)
                            const availableSpace = usePreset ? 300 : availableSpaceForImage
                            const step = diff * availableSpace * sensivity
                            const stepClamped = -step
                            // const hasSpace = Math.abs(step) < backgroundImageWidth * parallaxImage.scale - widgetDimensions.width && step < 0
                            const hasSpace = true
                            // const moreThanNull = step < 0
                            const moreThanNull = true
                            // console.log('parallax Wix.Events.SCROLL - step: ', step)
                            // console.log('parallax Wix.Events.SCROLL - hasSpace: ', hasSpace)
                            // console.log('parallax Wix.Events.SCROLL - moreThanNull: ', moreThanNull)
                            if (moreThanNull) {

                                if (hasSpace) {
                                    if (usePreset) {
                                        $(`.parallaxBackground > svg > g > *:not(.immutable)`).css('transform', `translateX(${stepClamped}px)`)
                                    } else {
                                        dynamics.stop(slider);
                                        dynamics.css(slider, {
                                            backgroundPositionX: `${parallaxImage.offsetX + stepClamped}px`,
                                            transition: '.25s',
                                        });
                                    }

                                } else {
                                    dynamics.stop(slider);
                                    dynamics.css(slider, {
                                        backgroundPositionX: `${-(backgroundImageWidth * parallaxImage.scale - widgetDimensions.width)}px`,
                                        transition: '.1s',
                                    });

                                }
                            }
                        }
                    });
                    break;
                case 'zoom-in':
                    let breakpointZoomIn = 100;
                    if (usePreset) {
                        $(`.parallaxBackground > svg > g`).css('transition', '.4s')
                    }
                    Wix.addEventListener(Wix.Events.SCROLL, (data) => {
                        if (data.scrollTop + data.documentHeight > data.y) {
                            const diff = data.y < data.documentHeight ?
                                remapValue(data.scrollTop, 0, data.documentHeight / 2, 0, 1) :
                                remapValue(data.scrollTop, data.y - data.documentHeight - breakpointZoomIn, data.y + data.height / 2 - data.documentHeight / 2, 0, 1)
                            const scale = parallaxImage.scale + diff
                            // Adjust the shift to center the zoom effect
                            const newOffsets = calculateAbsoluteFromCenterPoint(centerPoint, {
                                width: widgetDimensions.width,
                                height: widgetDimensions.height
                            },
                                {
                                    width: imgDims.width,
                                    height: imgDims.height
                                },
                                scale * 100
                            )

                            if (usePreset) {
                                $(`.parallaxBackground > svg > g`).css('scale', `${100 + diff * 100}%`)
                            } else {
                                dynamics.css(slider, {
                                    backgroundSize: `${scale * 100}%`,
                                    backgroundPositionX: `${newOffsets.transformX}px`,
                                    backgroundPositionY: `${newOffsets.transformY}px`,
                                    transition: '.4s',
                                });
                            }
                        }
                    });
                    //
                    // this.startScale = 0
                    // this.signScale = 1
                    // setInterval(() => {
                    //     this.startScale += 0.01 * this.signScale
                    //     if (this.startScale >= 1 || this.startScale <= 0) {
                    //         this.signScale *= -1
                    //     }
                    //     const newScale = parallaxImage.scale + this.startScale
                    //     const newOffsets = calculateAbsoluteFromCenterPoint(centerPoint, {
                    //         width: widgetDimensions.width,
                    //         height: widgetDimensions.height
                    //     },
                    //         {
                    //             width: imgDims.width,
                    //             height: imgDims.height
                    //         },
                    //         newScale * 100
                    //     )
                    //     dynamics.css(slider, {
                    //         backgroundSize: `${newScale * 100}%`,
                    //         backgroundPositionX: `${newOffsets.transformX}px`,
                    //         backgroundPositionY: `${newOffsets.transformY}px`,
                    //         transition: '.4s',
                    //     });
                    // }, 40)
                    break;
                case 'zoom-out':
                    if (usePreset) {
                        $(`.parallaxBackground > svg > g`).css('scale', `${100 + 100}%`)
                        $(`.parallaxBackground > svg > g`).css('transition', '.4s')
                    } else {
                        const newOffsets = calculateAbsoluteFromCenterPoint(centerPoint, {
                            width: widgetDimensions.width,
                            height: widgetDimensions.height
                        },
                            {
                                width: imgDims.width,
                                height: imgDims.height
                            },
                            (parallaxImage.scale + 1) * 100
                        )
                        dynamics.css(slider, {
                            backgroundSize: `${(parallaxImage.scale + 1) * 100}%`,
                            backgroundPositionX: `${newOffsets.transformX}px`,
                            backgroundPositionY: `${newOffsets.transformY}px`,
                            transition: 'none',
                        });
                    }
                    let breakpointZoomOut = 100;
                    Wix.addEventListener(Wix.Events.SCROLL, (data) => {
                        if (data.scrollTop + data.documentHeight > data.y) {
                            const diff = data.y < data.documentHeight ?
                                remapValue(data.scrollTop, 0, data.documentHeight / 2, 1, 0) :
                                remapValue(data.scrollTop, data.y - data.documentHeight - breakpointZoomOut, data.y + data.height / 2 - data.documentHeight / 2, 1, 0)
                            const scale = parallaxImage.scale + diff
                            // Adjust the shift to center the zoom effect
                            const newOffsetsPL = calculateAbsoluteFromCenterPoint(centerPoint, {
                                width: widgetDimensions.width,
                                height: widgetDimensions.height
                            },
                                {
                                    width: imgDims.width,
                                    height: imgDims.height
                                },
                                scale * 100
                            )
                            if (usePreset) {
                                $(`.parallaxBackground > svg > g`).css('scale', `${100 + diff * 100}%`)
                            } else {
                                dynamics.css(slider, {
                                    backgroundSize: `${scale * 100}%`,
                                    backgroundPositionX: `${newOffsetsPL.transformX}px`,
                                    backgroundPositionY: `${newOffsetsPL.transformY}px`,
                                    transition: '.4s',
                                });
                            }
                        }
                    });
                    break;

                default:
                    let breakpoint = 0;
                    Wix.addEventListener(Wix.Events.SCROLL, (data) => {
                        if (data.scrollTop + data.documentHeight > data.y) {
                            const diff = data.y > data.documentHeight ? data.y - data.scrollTop - data.documentHeight : -data.scrollTop - breakpoint;
                            const backgroundImageHeight = widgetDimensions.width / parallaxImage.width * parallaxImage.height
                            const step = diff * sensivity + this.props.settingsReducer.parallaxImage[0].offsetY
                            const hasSpace = Math.abs(step) < backgroundImageHeight * parallaxImage.scale - widgetDimensions.height && step < 0
                            const moreThanNull = step < 0

                            // console.log('parallax Wix.Events.SCROLL - step: ', step)
                            // console.log('parallax Wix.Events.SCROLL - hasSpace: ', hasSpace)
                            // console.log('parallax Wix.Events.SCROLL - moreThanNull: ', moreThanNull)
                            if (usePreset) {
                                $(`.parallaxBackground > svg > g > *:not(.immutable)`).css('transform', `translateY(${step - this.props.settingsReducer.parallaxImage[0].offsetY}px)`)
                            } else {
                                if (moreThanNull) {

                                    if (hasSpace) {


                                        dynamics.stop(slider);
                                        dynamics.css(slider, {
                                            backgroundPositionY: `${step}px`,
                                            transition: '.95s',
                                        });
                                    } else {
                                        dynamics.stop(slider);
                                        dynamics.css(slider, {
                                            backgroundPositionY: `${-(backgroundImageHeight * parallaxImage.scale - widgetDimensions.height)}px`,
                                            transition: '.95s',
                                        });

                                    }
                                }
                            }
                        }
                    });
                    break;

            }
            if (usePreset) {
                const gLengths = $(`.parallaxBackground > svg > g > *:not(.immutable)`).length
                const startTime = .25
                const endTime = 1
                const step = (endTime - startTime) / gLengths
                setTimeout(() => {
                    $(`.parallaxBackground > svg > g > *:not(.immutable)`).each((index, item) => {
                        const time = startTime + step * index
                        // item.style.transition = `${startTime + Math.random() / 2}s`
                        item.style.transition = `${time}s`
                        // if (index % 2 === 0) {
                        //     backgroundPresetEvenPaths.push(item)
                        // } else {
                        //     backgroundPresetOddPaths.push(item)
                        // }
                    })
                }, 10)

            }
        }
    }

    // симулировать отпускание мышки, если курсор выходит за пределы слайдера при зажатой мышке;
    // это для того, чтобы не возникал эффект залипания
    triggerMouseUp(e) {
        let event = new MouseEvent("mouseup", {
            bubbles: true,
            cancelable: true,
            clientX: e.pageX,
            clientY: e.pageY
        });
        e.currentTarget.dispatchEvent(event);
    }

    isDisableRightClick(e) {
        if (this.props.settingsReducer.hasDisableRightClick) {
            e.preventDefault()
            e.stopPropagation()
        }
    }

    // показать уведомление, что настройки не применились из-за отсутствия премиума
    renderNoPremiumAttention() {
        return (
            <AttentionContainer >
                To view all selected settings, upgrade the application.
            </AttentionContainer>
        )
    }

    renderTrialAddSaleTooltip() {
        if (!this.state.showTrialAddSaleTooltip) {
            return <div></div>
        }

        return (
            <div style={{ position: 'absolute', top: '0px', left: '2px', zIndex: 99999, pointerEvents: 'none' }}>
                <img
                    src={trial_add_widget_tooltip}
                />
            </div>
        )
    }

    render() {
        const deviceType = Wix.Utils.getDeviceType();
        const viewMode = this.state.viewMode || Wix.Utils.getViewMode()
        const isEditorMode = viewMode === 'editor'
        const isPreview = viewMode === 'preview'

        const { settingsCorrectedToPremium, settingsWasChangedInCorrectToPremuim } = getSettingsCorrectedToPremium(this.props.settingsReducer, viewMode, this.props.premiumReducer)

        // получить массив слайдов, где удалены скрытые слайды и капчи
        const slides = getVisibleSlides(settingsCorrectedToPremium.slides)
        let convertedSlides = slides

        const widgetBgColor = this.props.settingsReducer.hasWidgetBgColor ? this.props.settingsReducer.widgetBgColor : 'transparent'
        const widgetContainerStyles = {
            height: `${this.getSliderVerticalHeight()}px`,
            backgroundColor: slides.length > 0 ? widgetBgColor : `#fff`,
            backgroundImage: slides.length > 0 ? '' : `url(${background})`,
            backgroundSize: window.innerWidth / window.innerHeight > 2.65 ? 'cover' : 'contain',
        }
        const settingsReducer = _.cloneDeep(settingsCorrectedToPremium)

        const isMobile = deviceType === 'mobile'

        let backgroundType = settingsCorrectedToPremium.backgroundType
        if (backgroundType === undefined) {
            backgroundType = settingsCorrectedToPremium.hasParallax ? 'image' : 'none'
        }

        // console.log('backgroundType', backgroundType)
        // console.log('parallaxImage', parallaxImage)
        // let parallaxImage = utils.convertParallaxImage(
        //     settingsReducer.parallaxImage[0],
        //     isMobile ? settingsReducer.widgetDimensions.editedWidthMobile : settingsReducer.widgetDimensions.editedWidth,
        //     isMobile ? settingsReducer.widgetDimensions.editedHeightMobile : settingsReducer.widgetDimensions.editedHeight,
        //     window.innerWidth,
        //     this.getSliderVerticalHeight(),
        //     isMobile
        // )
        let parallaxImage = this.state.parallaxImage
        const parallaxStyles = {
            position: 'absolute',
            height: this.getSliderVerticalHeight() || '100%',
            display: (backgroundType === 'image' && slides.length > 0) ? 'block' : 'none',
            background: `url(${'https://media.wix.com/media/' + parallaxImage.relativeUri})`,
            width: '100%',
            backgroundSize: `${this.state.deviceType === 'desktop' ? parallaxImage.scale * 100 : parallaxImage.mobileScale * 100}%`,
            backgroundPosition: `${this.state.deviceType === 'desktop' ? parallaxImage.offsetX : parallaxImage.mobileOffsetX}px ${this.state.deviceType === 'desktop' ? parallaxImage.offsetY : parallaxImage.mobileOffsetY}px`,
            backgroundRepeat: 'no-repeat',
            transformOrigin: 'center center',
        }

        const showNoPremiumAttention = isPreview && !this.props.premiumReducer.showProfessionalPremiumSettings && settingsWasChangedInCorrectToPremuim
        const isCustomArrows = this.props.settingsReducer.selectedArrowsDesign == ARROWS_DESIGN.vector
        const customArrowsSettings = this.props.settingsReducer.customArrowsSettings ? this.props.settingsReducer.customArrowsSettings : { color: null, hoverColor: null }
        const arrow = this.props.settingsReducer.customArrows !== undefined ? vectorArrowsArray[this.props.settingsReducer.customArrows] : { fillRule: 'none' }

        const useBackgroundPreset = backgroundType === 'preset' || backgroundType === 'preset-3d'

        const backgroundPresetSettings = this.props.settingsReducer.backgroundPresetSettings

        const preset3DSettings = this.props.settingsReducer.preset3DSettings

        const presetType = backgroundPresetSettings ?
            backgroundType === 'preset' ?
                backgroundPresetSettings.type :
                backgroundPresetSettings.type3D
            :
            'none'

        const settingsForType = preset3DSettings ? preset3DSettings[presetType] : {}


        if (this.state.isIncognito) {
            return <IncognitoMode />
        } else if (this.props.settingsReducer.dataIsLoad) {

            return (

                <WidgetContainerStyle
                    style={widgetContainerStyles}
                    onContextMenu={(e) => this.isDisableRightClick(e)}
                >
                    {this.renderTrialAddSaleTooltip()}
                    {!this.props.premiumReducer.showSmartPremiumSettings && !isEditorMode &&
                        <Watermark className={'watermark'} />
                    }
                    {!this.props.premiumReducer.showSmartPremiumSettings && !isEditorMode &&
                        <LtPoweredBy>
                            <span>Powered by Impressive Interactive Section</span>
                        </LtPoweredBy>

                    }

                    {showNoPremiumAttention && this.renderNoPremiumAttention()}
                    <LightSliderContainer
                        id="lightslider-container"
                        deviceType={this.state.deviceType}
                        {...parallaxImage}
                        {...this.state.sliderStyle}
                        slideLength={convertedSlides.length}
                        arrowsFillColor={arrow.fillRule == 'stroke' ? 'transparent' : customArrowsSettings.color}
                        arrowsFillHoverColor={arrow.fillRule == 'stroke' ? 'transparent' : customArrowsSettings.hoverColor}
                        arrowsStrokeColor={customArrowsSettings.color}
                        arrowsStrokeHoverColor={customArrowsSettings.hoverColor}
                        customArrows={isCustomArrows}
                    >

                        {
                            useBackgroundPreset &&
                            <RenderPreset
                                type={presetType}
                                colors={backgroundPresetSettings.colors}
                                width={window.innerWidth}
                                height={window.innerHeight}
                                addMinusHeight={window.innerHeight - this.getSliderVerticalHeight()}
                                overflowHeight={this.getSliderVerticalHeight()}
                                className='parallaxBackground'
                                active={true}
                                backgroundColor={widgetBgColor}
                                presetSettings={settingsForType}
                                // enableFpsStat
                                playState={this.state.play3DState}
                                mobile={isMobile}
                            />
                        }

                        <div
                            className='parallaxBackground'
                            style={parallaxStyles}
                            title={this.props.settingsReducer.seoText}
                        />


                        <LightSlider id="lightslider"
                            onMouseOver={() => this.stopAnimationsOnHover()}
                            onMouseLeave={(e) => {
                                this.triggerMouseUp(e)
                                this.playAnimationsOnHover(slides)
                            }}
                        >
                            {convertedSlides.map((slide, index) => {
                                // обязательно указать demoIsShow в ключе к слайду, иначе он не перерисуется при получении демо натроек
                                return (
                                    <Slide
                                        slide={slide}
                                        key={`slide-${index}-${this.props.settingsReducer.demoIsShow}`}
                                        slideIndex={index}
                                        height={this.getSliderVerticalHeight()}
                                        widgetDimensions={this.props.settingsReducer.widgetDimensions}
                                        lang={this.state.lang}
                                        locale={this.state.locale}
                                    />
                                )
                            })}
                        </LightSlider>
                    </LightSliderContainer>
                    <WidgetRateLogicWatcher viewMode={Wix.Utils.getViewMode()} />
                </WidgetContainerStyle>
            )
        } else {
            return <UI.preloader />
        }

    }
}

function mapStateToProps(state) {
    return state;
}

export default connect(mapStateToProps)(WidgetContainer);